import LangSwitcher from './Langs';
export default LangSwitcher;